import { createElementBlock as l, openBlock as n, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function r(c, e) {
  return n(), l("svg", o, e[0] || (e[0] = [
    t("path", {
      fill: "#069",
      "fill-rule": "evenodd",
      d: "M21.974 12.054c0 4.355-3.948 7.935-8.273 7.914H9.98C5.603 19.99 2 16.41 2 12.054 2 7.292 5.603 3.998 9.98 4H13.7c4.325-.002 8.273 3.29 8.273 8.054m-19.22-.079c0-4.037 3.241-7.308 7.24-7.31 4.001.002 7.242 3.273 7.243 7.31 0 4.037-3.242 7.308-7.242 7.31-4-.002-7.24-3.273-7.241-7.31M8.35 7.651a4.64 4.64 0 0 0-2.946 4.324 4.64 4.64 0 0 0 2.946 4.323zm3.286 0V16.3a4.64 4.64 0 0 0 2.949-4.325 4.64 4.64 0 0 0-2.949-4.324",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const i = { render: r };
export {
  i as default,
  r as render
};
//# sourceMappingURL=ic_payment_dinersclub-B9Y_KbUc.js.map
